export default "__VITE_ASSET__3d064772__"